import en from './translations/en';
import es from './translations/es';
import fr from './translations/fr';
import pt from './translations/pt';
import axios from 'axios';
import store from '../store/index';
import { Settings } from 'luxon';

const storeLocale = () => store.getters['preferences/GET_LOCALE'];

export const i18nMessages = {
  en,
  es,
  fr,
  pt,
};

export const supportedLocales = [
  {
    code: 'en',
    name: 'English',
    iso: 'en-US',
  },
  {
    code: 'es',
    name: 'Español',
    iso: 'es-ES',
  },
  {
    code: 'fr',
    name: 'Français',
    iso: 'fr-FR',
  },
  {
    code: 'pt',
    name: 'Português',
    iso: 'pt-PT',
  },
];

export function setI18nLanguage(lang) {
  // !! Important: Don't change language because of infinite loop
  store.commit('preferences/setLocale', lang);

  axios.defaults.headers.common['Accept-Language'] = lang;
  if (document) {
    document.querySelector('html').setAttribute('lang', lang);
  }

  Settings.defaultLocale = lang;

  return lang;
}

export function detectUserLocaleFromStore() {
  /**
   * Check the store. If `locale` is found, use it.
   * Else detect from system
   */
  /**
   * @type {string | null}
   */
  let detectedUserLocale = storeLocale();
  let userLocale = undefined;

  if (detectedUserLocale.includes('-')) {
    detectedUserLocale = detectedUserLocale.split('-')[0];
  }
  if (supportedLocales.find((locale) => locale.code === detectedUserLocale)) {
    userLocale = detectedUserLocale;
  }

  if (!userLocale) {
    userLocale = 'en';
  }

  return userLocale;
}
